/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".document-picker-container{min-height:400px}.document-picker-container .doc-breadcrumb{padding:10px 15px;border-bottom:1px solid #eee}.document-picker-container .doc-file-list{padding:10px 15px;min-height:300px;max-height:calc(100vh - 250px);overflow-y:auto}.document-picker-container .doc-footer{padding:10px 15px;border-top:1px solid #eee;text-align:right;display:flex;justify-content:flex-end;gap:8px}"];
export { styles as styles };
